import { PackageIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { Modal } from '@/components/ui/modal'

import * as S from './access-code-modal.styled'

interface AccessCodeModalProps {
  accessCode: string | null
  onClose: () => void
}

export const AccessCodeModal = ({ accessCode, onClose }: AccessCodeModalProps) => {
  const { t } = useTranslation(['packages'])

  return (
    <Modal
      title={t('packages:accessCodeModal.title')}
      headerIcon={PackageIcon}
      footer={null}
      onClose={onClose}
    >
      <S.Container>
        <S.Instructions>{t('packages:accessCodeModal.instructions')}</S.Instructions>
        <S.CodeDisplay>
          <S.CodeValue>{accessCode}</S.CodeValue>
        </S.CodeDisplay>
      </S.Container>
    </Modal>
  )
}
